import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Button } from './ui/Button';
export function HeroSection() {
  const scrollToOffer = () => {
    document.getElementById('offer-section')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="pt-16 pb-20 px-4 md:pt-24 md:pb-32 max-w-6xl mx-auto" data-id="element-48">
      <div className="flex flex-col md:flex-row items-center gap-12 md:gap-16" data-id="element-49">
        <div className="flex-1 text-center md:text-left" data-id="element-50">
          <FadeIn data-id="element-51">
            <h1 className="font-serif text-4xl md:text-5xl lg:text-6xl font-bold leading-tight text-[#2D2A26] mb-6 text-balance" data-id="element-52">
              Deja de repetir 20 veces:{' '}
              <span className="text-[#E8604C]" data-id="element-53">
                El plan de 7 días para que tu hijo te escuche a la primera
              </span>{' '}
              (y dejes de gritar).
            </h1>
          </FadeIn>

          <FadeIn delay={200} data-id="element-54">
            <h2 className="font-sans text-lg md:text-xl text-[#2D2A26]/80 leading-relaxed mb-8 max-w-2xl mx-auto md:mx-0" data-id="element-55">
              Un sistema práctico de "micro-conexiones" y límites firmes
              diseñado para madres y padres agotados que quieren recuperar la
              paz en casa sin usar el miedo.
            </h2>
          </FadeIn>

          <FadeIn delay={400} data-id="element-56">
            <Button onClick={scrollToOffer} className="w-full md:w-auto text-lg shadow-lg" data-id="element-57">
              Quiero que me escuche: Descargar el Plan
            </Button>
          </FadeIn>
        </div>

        <div className="flex-1 w-full max-w-md mx-auto md:max-w-none" data-id="element-58">
          <FadeIn delay={300} data-id="element-59">
            <div className="relative" data-id="element-60">
              <div className="absolute inset-0 bg-[#F5A623]/20 rounded-3xl transform rotate-3 scale-105 transition-transform duration-500 hover:rotate-6" data-id="element-61"></div>
              <img src="https://cdn.magicpatterns.com/uploads/eyzyKweaDsKdFVdDPT4QUu/HIJOS_QUE_ESCUCHAN_PORTADA_EBOOK.png" alt="Portada del ebook Hijos que Escuchan" className="relative z-10 w-full h-auto rounded-2xl shadow-2xl" data-id="element-62" />
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}